import React, { useState } from "react";
import MonthCard from "./component/MonthCard";
import Counter from "../../../components/counter/Counter";
import SwipeableDiv from "./component/SwipeableDiv";

interface CalenderPageProps {
  // Add props here
}

const CalenderPage: React.FC<CalenderPageProps> = () => {
  const today = new Date();

  const [currentMonth, setCurrentMonth] = useState<number>(
    today.getMonth() + 1 // tháng (1–12)
  );

  const [currentYear, setCurrentYear] = useState<number>(
    today.getFullYear() // năm
  );
  // Hàm chuyển tháng khi vuốt
  const goToNextMonth = () => {
    if (currentMonth === 12) {
      setCurrentMonth(1);
      setCurrentYear((prev) => prev + 1);
    } else {
      setCurrentMonth((prev) => prev + 1);
    }
  };

  const goToPrevMonth = () => {
    if (currentMonth === 1) {
      setCurrentMonth(12);
      setCurrentYear((prev) => prev - 1);
    } else {
      setCurrentMonth((prev) => prev - 1);
    }
  };
  return (
    <div className="  text-white py-4 w-full">
      <div className=" w-full flex justify-center mb-3 -mt-5">
        <p className="text-4xl md:text-5xl font-extrabold text-red-600 drop-shadow-lg tracking-wide">
          LỊCH VẠN NIÊN
        </p>
      </div>
      <SwipeableDiv
        className="w-full"
        onSwipeLeft={goToNextMonth} // vuốt trái → tháng sau
        onSwipeRight={goToPrevMonth} // vuốt phải → tháng trước
      >
        <MonthCard month={currentMonth} year={currentYear} />
      </SwipeableDiv>

      <div className="mt-3 px-2 w-full flex justify-center">
        <div className="w-full rounded-full bg-black/80 p-2 flex justify-between items-center gap-4">
          <Counter
            defaultValue={currentYear}
            minW="w-[85px] iphone15promax:w-[120px]"
            onChange={(value) => setCurrentYear(value)}
          />
          <Counter
            defaultValue={currentMonth}
            minW="w-[85px] iphone15promax:w-[120px]"
            label="Tháng"
            color="text-red-500"
            fontSize="text-[18px]"
            onChange={(value) => {
              if (value > 12) {
                setCurrentMonth(1);
                setCurrentYear((prev) => prev + 1);
              } else if (value < 1) {
                setCurrentMonth(12);
                setCurrentYear((prev) => prev - 1);
              } else {
                setCurrentMonth(value);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CalenderPage;
